import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const STAFF_DOMAIN = '@dongyeongtour.co.kr';

/** .env.local 이 비면 SDK 가 의미 없는 에러를 뱉는다 — 화면에서 원인을 먼저 알려준다. */
export const firebaseConfigured = Boolean(config.apiKey && config.appId);

export const app = initializeApp(config);
export const auth = getAuth(app);

/** Functions 는 asia-northeast3 에 있다. 리전을 빼면 us-central1 을 찾아 404 가 난다. */
export const functions = getFunctions(app, 'asia-northeast3');

export async function signIn(): Promise<void> {
  const provider = new GoogleAuthProvider();
  // 계정 선택을 매번 띄운다 — 공용 PC 에서 남의 계정으로 들어가는 사고를 막는다.
  provider.setCustomParameters({ prompt: 'select_account', hd: 'dongyeongtour.co.kr' });
  const cred = await signInWithPopup(auth, provider);
  if (!cred.user.email?.endsWith(STAFF_DOMAIN)) {
    await signOut(auth);
    throw new Error(`사내 계정(${STAFF_DOMAIN})으로만 로그인할 수 있습니다.`);
  }
}

export async function signOutNow(): Promise<void> {
  await signOut(auth);
}
